import React, { Component } from 'react';
import {MasterLayout} from 'layout';
import {Link, browserHistory} from 'react-router';
import ThongTinKeHoachThanhTra from './ThongTinKeHoachThanhTra.jsx';
import ThongTinCuocThanhTra from './ThongTinCuocThanhTra.jsx';
import { ThanhTra } from 'api';
import { get } from 'lodash';

export default class ThongTinChiTietCuocThanhTra extends Component {
  constructor(props) {
    super(props);
    this.state = {
      type: ''
    }
  }

  componentDidMount() {
    let id = this.props.params && this.props.params.id
    this.getChiTietCuocThanhTra(id);
    if (this.props.route.type) {
      this.setState({
        type: this.props.route.type
      });
    }
  }

  componentWillReceiveProps(nextProps) {
    const oldId = this.props.params && this.props.params.id;
    const newId = nextProps.params && nextProps.params.id;
    if (newId !== oldId) {
      this.getChiTietCuocThanhTra(newId);
    }
    if (nextProps.route.type) {
      this.setState({
        type: nextProps.route.type
      });
    }
  }


  onClickClose () {
    browserHistory.goBack();
  }

  getChiTietCuocThanhTra(id) {
    ThanhTra.actions.getChiTietCuocThanhTra.request({id: id}).then(res => {
      if (res.data) {
        this.setState({
          dataDetail: res.data
        },() => {
          this.getChiTietLienQuanCuocThanhTra(id);
        });
      }
    });
  }

  getChiTietLienQuanCuocThanhTra(id) {
    ThanhTra.actions.getChiTietLienQuanCuocThanhTra.request({id:id}).then(res => {
      if (res.data) {
        this.setState({
          listTaiLieuVanThuThongTinCuocThanhTra: res.data.listTaiLieuVanThuThongTinCuocThanhTra
        });
      }
    });
  }


  render() {
    const dataDetail = this.state.dataDetail;
    const keHoachThanhTraInfo = dataDetail && dataDetail.keHoachThanhTraInfo ? dataDetail.keHoachThanhTraInfo : {}
    // alias = ChiTietThanhTraTrung thì sẽ hiển thị form của thanh tra trùng
    const isKiemTra = get(dataDetail, 'loaiCuoc.value') === 'KIEM_TRA';
    const loaiCuocText = isKiemTra ? 'kiểm tra' : 'thanh tra';
    const keHoachText = isKiemTra ? 'KHKT' : 'KHTT';
    return (
      <MasterLayout routerName={this.props.route.name}>
        <div className="center wrap-block">
          <div className="back-foward">
            <Link onClick={ this.onClickClose.bind(this, 'close') } title="">Về trang trước</Link>
          </div>
          <div className="heading">
            <h2 className="heading-title icon-detail">
              Thông tin chi tiết cuộc {loaiCuocText}
            </h2>
          </div>
          <div className="page-wrapper">
            <ThongTinKeHoachThanhTra data={keHoachThanhTraInfo} loaiCuocText={loaiCuocText} keHoachText={keHoachText} />
          </div>
          <div className="page-wrapper">
            <ThongTinCuocThanhTra type={this.state.type} dataCuocThanhTra={this.state} loaiCuocText={loaiCuocText} />
          </div>
          <div className="box-bottom ttt-bottom">
            <Link className="btn-action btn-close action-todo" role="button" onClick={this.onClickClose.bind(this)}><span>Đóng</span></Link>
          </div>
        </div>
      </MasterLayout>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/modules/thanh-tra-trung/ThongTinChiTietCuocThanhTra.jsx